// extracted by mini-css-extract-plugin
export default {"header":"pyVwt","logo":"r2Jzc","title":"OfhGS","description":"OxP3h","email":"rl3nY"};